/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../index';

/**
 * The common properties of a resource with specific data.
 */
export interface ResourceApiKey {
    /** The annotations of the resource. */
    annotations: Record<string, string>;
    /** The creation date of the resource. */
    createdAt: Date;
    /** The data of the resource. */
    data: Truvity.ApiKey;
    /** The deletion date of the resource. */
    deletedAt?: Date;
    /** The ETag of the resource. */
    etag: string;
    /** The ID of the resource. */
    id: string;
    /** The kind of the resource. */
    kind: Truvity.ResourceKind;
    /** The labels of the resource. */
    labels: Record<string, string>;
    /** The update date of the resource. */
    modifiedAt: Date;
    /** The revision of the resource. */
    revision: number;
}
